import React from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle } from 'lucide-react';
import { eligibilityRequirements } from '../mock';

export const Eligibility = () => {
  return (
    <section id="eligibility" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Eligibility Requirements
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              See if you qualify for a reverse mortgage in Colorado. Most homeowners 62+ 
              meet these straightforward requirements.
            </p>

            {/* Requirements List */}
            <div className="space-y-4">
              {eligibilityRequirements.map((item) => (
                <div 
                  key={item.id}
                  className="flex items-start space-x-3 p-4 bg-green-50 rounded-lg border border-green-200"
                >
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 leading-relaxed">{item.requirement}</p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 p-6 bg-blue-50 rounded-xl border-2 border-blue-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Not sure if you qualify?
              </h3>
              <p className="text-gray-600 mb-4">
                Every situation is unique. Schedule a free consultation and I'll review 
                your specific circumstances with no obligation.
              </p>
              <button 
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-blue-600 hover:text-blue-700 font-semibold hover:underline"
              >
                Get Your Free Consultation →
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.pexels.com/photos/8441861/pexels-photo-8441861.jpeg"
                alt="Professional mortgage consultation with seniors"
                className="w-full h-[600px] object-cover"
              />
              
              {/* Overlay Stats */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8">
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-white">
                    <p className="text-3xl font-bold mb-1">62+</p>
                    <p className="text-sm opacity-90">Minimum Age Required</p>
                  </div>
                  <div className="text-white">
                    <p className="text-3xl font-bold mb-1">$0</p>
                    <p className="text-sm opacity-90">Monthly Payments</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="hidden lg:block absolute -z-10 -bottom-6 -right-6 w-full h-full bg-blue-100 rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
